<template>
  <div>
    <billinglayer2 :key="key" :data="data" :image="image"></billinglayer2>
  </div>
</template>

<script>
import Api from "@/services/Api";
import dateformat from "dateformat";
import layer2Billing from "@/components/Layer2Billing.vue";
export default {
  components: {
    billinglayer2: layer2Billing
  },
  data() {
    return {
      allBills: [],
      data: [],
      image: '',
      key:1
    }},
  async created() {
    // let route = await this.$store.state.currentOrg.org.permissions.filter(function(el){
    //     return el.url === '/billing'})
    //   if (route.length > 0) {
    //   await this.$store.dispatch("setCurrentRoute", route[0]);
    //   if (this.authRead(this.$store.state.currentRoute) === true) {
    //     this.initialize();
    //   }
    // } else {
    //   this.$router.push({ name: "SplashPage" });
    // }
    this.initialize()
  },
  methods: {
    formatDate(date) {
      if (date !== null) {
        return dateformat(date, "dd/mm/yyyy");
      } else {
        null;
      }
    },
    async getAllBills(){
        await Api()
      .get('/integrations/byName/LibreNMS')
      .then(async response=>{
        this.apiUrl=response.data.apiUrl
        this.apiToken=response.data.token
        await Api()
        .get('/libre/allBills',{
          params: {
            apiUrl: this.apiUrl,
            apiToken: this.apiToken
          }
        }).then(response=>{
            this.allBills= response.data.bills
        })
        for (let i=0; i< this.allBills.length;i++){
        await Api()
        .get('/libre/billHistory/'+this.allBills[i].bill_id,{
          params: {
            apiUrl: this.apiUrl,
            apiToken: this.apiToken
          }
        })
        .then(async response=>{
            await this.data.push({billId: this.allBills[i].bill_id, billName: this.allBills[i].bill_name, data: response.data.bill_history})
        })
        }
        
        Api()
        .get('/libre/billGraph/20',{
          params: {
            apiUrl: this.apiUrl,
            apiToken: this.apiToken
          }
        })
        .then(response=>{
          console.log(response)
          let buffer = new Buffer(response.data)
          console.log(buffer)
          var bytes = new Uint8Array(response.data.body);
          console.log(bytes)
          this.image=response.data.image
              var binary = bytes.reduce((data, b) => data += String.fromCharCode(b), '');
              let src = "data:image/jpeg;base64," + btoa(binary);
              console.log(src)
        //   console.log(typeof response.data)
          
        })
      })
    },
    initialize(){
        this.getAllBills()
    }
  }
};
</script>
